<template>
  <fh-container justify-center>
    <fh-card justify-center>
      <v-card-title primary-title class="grey lighten-3">
        <h3 class="headline">No hay inventario inicial</h3>
      </v-card-title>
      <v-card-text>
        <v-list>
          <div v-if="getInventariosInicial.length === 0">
            <template v-if="temporada.temporadaHabilitada">
              <v-alert
                  type="info"
              >
                No fue registrado un inventario inicial. Carge su inventario inicial para continuar.
              </v-alert>
              <v-btn rounded color="primary" :to="{ name: 'InventarioInicial' }" class="mx-0">
                <v-icon small class="pr-1">fa-plus</v-icon>
                Cargar inventario
              </v-btn>
            </template>
            <template v-else>
              <v-alert
                  type="warning"
              >
                Ningún inventario inicial disponible.
                No puede agregar inventarios porque la temporada seleccionada fue deshabilitada.
              </v-alert>
            </template>
          </div>
        </v-list>
      </v-card-text>
    </fh-card>
  </fh-container>
</template>

<script>
  import FhContainer from '@/components/FhContainer'
  import FhCard from '@/components/FhCard'
  import {mapActions, mapGetters, mapState} from 'vuex'

  export default {
    name: 'ElegirFicha',
    components: {FhCard, FhContainer},
    props: ['next'],
    data() {
      return {
        disabled: false
      }
    },
    computed: {
      ...mapGetters('lotes',[
        'getInventariosInicial'
      ]),
      ...mapState('temporada', [
        'temporada',
      ]),
    },
    methods: {
      ...mapActions('lotes',[
        'fetchListaInventarios'
      ]),
    ...mapActions('fichas',['fetchFichaGanadera']),
    },
    async created () {
      try {
        await this.fetchFichaGanadera()
        await this.fetchListaInventarios()
        if (this.getInventariosInicial.length !== 0) {
          this.$router.push({path: this.$route.query.next || '/'})
        }
      } catch (e) {}
    },
  }
</script>

<style scoped>
  .fh-pointer {
    cursor: pointer;
  }
</style>
